import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import QueryString from 'qs';

import { Button, H6 } from 'design-system-web';

import { useWorkplaceOnboardingEnabled } from 'lane-shared/hooks/onboarding/useWorkplaceOnboardingEnabled';
import { useContinueAsGuest } from 'lane-shared/hooks/useContinueAsGuest';
import type { Channel } from 'application-types';
import styles from './index.scss';

export const CantFindCompany = ({
  parentCompany,
  invitedChannelId,
  onClick,
}: {
  parentCompany: Channel | null;
  invitedChannelId: string | null;
  onClick: () => void;
}) => {
  const isWorkplaceOnboardingEnabled = useWorkplaceOnboardingEnabled();
  const {
    isContinueAsGuestVisible,
    translationKeys: { noRecognizedOptionLabel },
  } = useContinueAsGuest();
  const { t } = useTranslation();

  if (!isContinueAsGuestVisible) {
    if (isWorkplaceOnboardingEnabled || parentCompany) {
      return null;
    }
  }

  return isWorkplaceOnboardingEnabled ? (
    <Button
      className={styles.buttonWorkplaceOnboarding}
      variant="text"
      onClick={onClick}
      size="large"
      fullWidth
    >
      {t(noRecognizedOptionLabel)}
    </Button>
  ) : (
    <Link
      to={{
        pathname: './building',
        ...(invitedChannelId && {
          search: QueryString.stringify({
            channelId: invitedChannelId,
          }),
        }),
      }}
    >
      <H6 className={styles.footerLink}>{t(noRecognizedOptionLabel)}</H6>
    </Link>
  );
};
